import React from "react";
import { CFooter } from "@coreui/react";
import { NavLink } from "react-router-dom";
import CIcon from "@coreui/icons-react";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const TheFooter = () => {
  return (
    <CFooter fixed={false} style={{ background: "#ffff" }}>
      <div className={"row"} style={{ width: "100%" }}>
        <div className="col-12 col-xs-12 col-sm-10  col-md-10 col-lg-3 col-xl-2 col-xxl-2">
          <NavLink to="" rel="noopener noreferrer">
            CG Forest
          </NavLink>
          <span className="ml-1">&copy; 2024</span>
        </div>
        <div
          className="col-12 col-xs-12 col-sm-10  col-md-12 col-lg-9 col-xl-10 col-xxl-10"
          style={{ fontWeight: 600 }}
        >
          <b>Support Team: </b>
             Devendra  -{" "}
          <CIcon
            name="cil-phone"
            style={{ transform: "rotate(90deg)", marginTop: "-0.1rem" }}
          />{" "}
          +91 6354 910 207 -{" "}
          <EmailOutlinedIcon
            style={{ fontSize: "1.15rem", marginTop: "-0.1rem" }}
          />{" "}
          <a href="mailto:devendra@procure247.com">devendra@procure247.com</a>
          &nbsp; &nbsp; | &nbsp; &nbsp;
          <div className="brShowHide">
            <br />
          </div>
          Dhruv Patel -{" "}
          <CIcon
            name="cil-phone"
            style={{ transform: "rotate(90deg)", marginTop: "-0.1rem" }}
          />{" "}
          +91 9274 416 926 -{" "}
          <EmailOutlinedIcon
            style={{ fontSize: "1.15rem", marginTop: "-0.1rem" }}
          />{" "}
          <a href="mailto:dhruv@procure247.com">dhruv@procure247.com</a>{" "}
        </div>
      </div>
    </CFooter>
  );
};

export default React.memo(TheFooter);
